import graphqlClient from '~/graphql/graphqlClient';

export interface MutationResetAttributesArgs {
  playerId: string;
  heroHandle: string;
  heroBuildId: string;
}

export interface AttributeChangeResult {
  heroHandle: string;
  heroBuild: any;
}

const mutation = `
mutation ResetAttributes(
  $playerId: String!
  $heroHandle: String!
  $heroBuildId: String!
) {
  resetAttributes(
    playerId: $playerId
    heroHandle: $heroHandle
    heroBuildId: $heroBuildId
  ) {
    heroHandle
    heroBuild
  }
}`;

export default async function mutationResetAttributes(args: MutationResetAttributesArgs) {
  return await graphqlClient.request<AttributeChangeResult>('resetAttributes', mutation, args);
}
